const FormInputStatus = Object.freeze({
    NotApplicable:0,
    Required:1,
    Optional:2,
    Disabled:3,
    Hidden:4,
    ReadOnly:5,
    Valid:6,
    Invalid:7,

    0:'NotApplicable',
    1:'Required',
    2:'Optional',
    3:'Disabled',
    4:'Hidden',
    5:'ReadOnly',
    6:'Valid',
    7:'Invalid' 
});


export default FormInputStatus;